"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const jwtDecode = require("jwt-decode");
class AuthData {
    constructor() {
        // id token
        this.user_jwt = false;
        // id token
        this.user_access_token = false;
        // refresh token
        this.user_refresh_token = false;
        this.domain_jwt = false;
        this.user_data = {};
        this.domain_data = {};
        this.setUserToken = token => {
            // todo: validity checks
            this.user_jwt = token;
            // @ts-ignore
            this.user_data = jwtDecode(token);
        };
        this.setAccessToken = token => {
            this.user_access_token = token;
        };
        this.setRefreshToken = token => {
            this.user_refresh_token = token;
        };
        this.setDomainToken = token => {
            // todo: validity checks
            this.domain_jwt = token;
            // @ts-ignore
            this.domain_data = jwtDecode(token);
        };
    }
    static getInstance() {
        if (!AuthData.instance) {
            AuthData.instance = new AuthData();
        }
        return AuthData.instance;
    }
    getUserToken() {
        return this.user_jwt;
    }
    ;
    getUserData() {
        return this.user_data;
    }
    getUserAccessToken() {
        return this.user_access_token;
    }
    ;
    getUserRefreshToken() {
        return this.user_refresh_token;
    }
    ;
    getDomainToken() {
        return this.domain_jwt;
    }
    ;
}
exports.Auth = AuthData.getInstance();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aERhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJpdmF0ZS9lcGhlbWVyYWwvYXV0aERhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsd0NBQXdDO0FBRXhDLE1BQU0sUUFBUTtJQXdCWjtRQWJBLFdBQVc7UUFDSCxhQUFRLEdBQWtCLEtBQUssQ0FBQztRQUV4QyxXQUFXO1FBQ0gsc0JBQWlCLEdBQWtCLEtBQUssQ0FBQztRQUVqRCxnQkFBZ0I7UUFDUix1QkFBa0IsR0FBa0IsS0FBSyxDQUFDO1FBRTFDLGVBQVUsR0FBRyxLQUFLLENBQUM7UUFDbkIsY0FBUyxHQUFRLEVBQUUsQ0FBQztRQUNwQixnQkFBVyxHQUFRLEVBQUUsQ0FBQztRQUl2QixpQkFBWSxHQUFHLEtBQUssQ0FBQyxFQUFFO1lBQzVCLHdCQUF3QjtZQUN4QixJQUFJLENBQUMsUUFBUSxHQUFHLEtBQUssQ0FBQztZQUN0QixhQUFhO1lBQ2IsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDcEMsQ0FBQyxDQUFDO1FBVUssbUJBQWMsR0FBRyxLQUFLLENBQUMsRUFBRTtZQUM5QixJQUFJLENBQUMsaUJBQWlCLEdBQUcsS0FBSyxDQUFDO1FBQ2pDLENBQUMsQ0FBQztRQU1LLG9CQUFlLEdBQUcsS0FBSyxDQUFDLEVBQUU7WUFDL0IsSUFBSSxDQUFDLGtCQUFrQixHQUFHLEtBQUssQ0FBQztRQUNsQyxDQUFDLENBQUM7UUFPSyxtQkFBYyxHQUFHLEtBQUssQ0FBQyxFQUFFO1lBQzlCLHdCQUF3QjtZQUN4QixJQUFJLENBQUMsVUFBVSxHQUFHLEtBQUssQ0FBQztZQUN4QixhQUFhO1lBQ2IsSUFBSSxDQUFDLFdBQVcsR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDdEMsQ0FBQyxDQUFDO0lBdkNzQixDQUFDO0lBdEJsQixNQUFNLENBQUMsV0FBVztRQUN2QixJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsRUFBRTtZQUN0QixRQUFRLENBQUMsUUFBUSxHQUFHLElBQUksUUFBUSxFQUFFLENBQUM7U0FDcEM7UUFDRCxPQUFPLFFBQVEsQ0FBQyxRQUFRLENBQUM7SUFDM0IsQ0FBQztJQTBCTSxZQUFZO1FBQ2pCLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQztJQUN2QixDQUFDO0lBQUEsQ0FBQztJQUVLLFdBQVc7UUFDaEIsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDO0lBQ3hCLENBQUM7SUFNTSxrQkFBa0I7UUFDdkIsT0FBTyxJQUFJLENBQUMsaUJBQWlCLENBQUM7SUFDaEMsQ0FBQztJQUFBLENBQUM7SUFNSyxtQkFBbUI7UUFDeEIsT0FBTyxJQUFJLENBQUMsa0JBQWtCLENBQUM7SUFDakMsQ0FBQztJQUFBLENBQUM7SUFVSyxjQUFjO1FBQ25CLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUN6QixDQUFDO0lBQUEsQ0FBQztDQUVIO0FBRVksUUFBQSxJQUFJLEdBQUcsUUFBUSxDQUFDLFdBQVcsRUFBRSxDQUFDIn0=